import { useStaticQuery, graphql } from 'gatsby'
import { decodeProductId } from 'src/utils/format'
import Link from 'src/components/Link'
import styled from '@emotion/styled'
import { typography } from 'src/styles'

const SwitcherWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 30px;
  margin-top: 30px;
  > div {
    width: 70px;
  }
  .img-wrapper {
    border-radius: 4px;
    position: relative;
    aspect-ratio: 1;
    width: 100%;
    margin-bottom: 6px;
    img {
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
    &:after {
      border: 1px solid currentcolor;
      content: '';
      display: block;
      position: absolute;
      top: -3px;
      left: -3px;
      bottom: -3px;
      right: -3px;
      z-index: 4;
      border-radius: 4px;
      box-sizing: border-box;
      transition: opacity .3s ease-in-out;
    }
  }
  a {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    ${ typography.bodyTiny }
    &:not(.active) {
      .img-wrapper {
        &:after {
          opacity: 0;
        }
      }
      &:hover {
        .img-wrapper {
          &:after {
            opacity: 1;
          }
        }
      }
    }
    &.active {
      opacity: 1;
    }
  }
`

const BeverageProductSwitcher = ({ beverages, pathname }) => {
  if (!beverages || beverages?.length < 3) {
    return false
  }

  const { allShopifyProduct } = useStaticQuery(
		graphql`
			query {
				allShopifyProduct {
			    edges {
			      node {
              title
			        handle
			        shopifyId
              featuredImage {
                src
                width
                height
              }
              variants {
                ...Variant
              }
			      }
			    }
			  }
			}
		`
	)

  const getProduct = id => {
		const decodedId = decodeProductId(id)
		const product = allShopifyProduct?.edges?.filter(product => product.node.shopifyId === decodedId)[0]?.node
		return {
      link: '/shop/' + product?.handle,
      title: product?.title,
      image: product?.featuredImage?.src
    }
	}

  const bevItems = beverages.filter(item => item?.node?.shopifyProductId !== 'placeholder')

  return (
    <SwitcherWrapper>
      {bevItems?.map(bev => {
        const item = bev?.node
        let itemUrl = false
        let itemTitle
        let itemImage

        if (item?.shopifyProductId) {
          itemUrl = getProduct(item.shopifyProductId)?.link
          itemTitle = getProduct(item.shopifyProductId)?.title
          itemImage = getProduct(item.shopifyProductId)?.image
        }
        if (!itemUrl) {
          return false
        }

        const active = pathname === itemUrl + '/'

        console.log(getProduct(item.shopifyProductId).link, pathname)

        return (
          <div key={itemUrl}>
            <Link to={itemUrl} className={active ? 'active' : ''}>
              <div className='img-wrapper'>
                <img src={itemImage} alt={itemTitle} />
              </div>
              {itemTitle}
            </Link>
          </div>
        )
      })}
    </SwitcherWrapper>
  )
}

export default BeverageProductSwitcher
